import * as React from 'react';
import { useAuth } from '../../../utils/hooks/use-auth';
import { useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { TabProps } from '../../../utils/interfaces/TabProps';
import { StyledTab } from '../../styles/style';

export default function BillingTab(props: TabProps) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(props.initPage);
  // tabの横の長さをタブの表示数で変更する
  const tabWidth = 40 - 20 * auth.userAuthority.substring(9, 11).split('').filter(char => char === '0').length;

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    switch (newValue) {
        case "invoice":
            navigate('/user/billing-document/invoice');
            break;
        case "specification":
            navigate('/user/billing-document/specification');
            break;
        default:
            break;
    }
  };

  return (
    <Box sx={{ width: '100%', borderBottom: 2, borderColor: '#0098CB' }}>
      <Box sx={{ width: tabWidth.toString() + "%" }}>
        <Tabs 
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="tab"
            sx={{ '& .MuiTab-root:not(:last-child)': { mr: 1 } }}
        >
          {auth.userAuthority[9] === "1"? <StyledTab label="請求書" value="invoice"/> : <div />}
          {auth.userAuthority[10] === "1"? <StyledTab label="明細書" value="specification"/> : <div />}
        </Tabs>
      </Box>
    </Box>
  );
}